export default __webpack_public_path__ + "images/5f429c3edd701cd6c0fd75a5a580bcfb.svg";